import { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Alert } from "./Alert";
import logo from "../img/logo_mrz.png"
import axios from "axios";
import { Register } from "./Register";


export function Login() {
  const [user, setUser] = useState({
    email: "",
    password: "",
  });
  const { login } = useAuth();
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const [requestAccess, setRequestAccess] = useState({
	name:'',
	email:'',
	phone: ''
  })

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await login(user.email, user.password);
      navigate("/admin-page");
    } catch (error) {
		console.log(user)
        if(error.message === "Firebase: Error (auth/wrong-password)."){
          setError("Contraseña Incorrecta");
        }
        else if(error.message === "Firebase: Error (auth/internal-error)."){
          setError("Por favor rellena los campos");
        }
        else if(error.message === "Firebase: Error (auth/invalid-email)."){
          setError("Email invalido");
        }
        else if(error.message === "Firebase: Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later. (auth/too-many-requests)."){
          setError("Has cometido muchos intentos. Por favor intentalo mas tarde");
        }
        else if(error.message === "Firebase: Error (auth/user-not-found)."){
          setError("Usuario No Encontrado");
        }
		else if(error.message === "Firebase: Error (auth/email-already-in-use)."){
			setError("Este correo ya esta en uso");
		  }
        else{
          setError(error.message)
        }
      }
  };

  const handleChange = ({ target: { value, name } }) =>{
    setUser({ ...user, [name]: value });
	
  }

  

  // const handleGoogleSignin = async () => {
  //   try {
  //     await loginWithGoogle();
  //     navigate("/");
  //   } catch (error) {

  //     setError(error.message);
  //   }
  // };

  // const handleResetPassword = async (e) => {
  //   e.preventDefault();
  //   if (!user.email) return setError("Write an email to reset password");
  //   try {
  //     await resetPassword(user.email);
  //     setError('We sent you an email. Check your inbox')
  //   } catch (error) {
  //     setError(error.message);
  //   }
  // };

const handleRequest=(e)=>{
	e.preventDefault()
	var FormData = require('form-data');
	var data = new FormData();
	data.append('name', requestAccess.name);
	data.append('email', requestAccess.email);
	data.append('phone', requestAccess.phone);

	var config = {
		method: 'post',
		url: 'https://miirza.com/includes/acceso_a_catalogo.php',
		data : data
	  };
	  
	  axios(config)
	  .then(function (response) {
		window.location.replace('https://miirza.com/');
	  })
	  .catch(function (error) {
		alert("OOOPS Algo ocurrio intenta nuevamente")
	  });
}

const handleBack = (e) =>{
	e.preventDefault()
	window.location.replace('https://miirza.com/');
}

  return (
    <div>
    

{/* <!-- Preloader --> */}
<div id="page-loading-blocs-notifaction" className="page-preloader"></div>
{/* <!-- Preloader END --> */}


{/* <!-- Main container --> */}
<div className="page-container">
    
{/* <!-- bloc-4 --> */}
<div className="bloc bloc-bkgrnd none bg-center bloc-fill-screen full-width-bloc l-bloc" id="bloc-4">

{/* <!-- bloc-5 --> */}
{/* <div className="bloc bloc-fill-screen bloc-style none bloc-bkgrnd bg-signin-bkgrnd d-bloc bg-center" id="bloc-5">
	<div className="width-container container">
		<div className="row no-gutters">
		
			<div className="col-lg-1 text-lg-center">
				<div className="vertical-divider text-lg-right">
				</div>
			</div>
			<div className="align-self-center col-md-10 offset-md-1 offset-lg-0 col-lg-5">
				<form onSubmit={handleSubmit} id="form_3" data-form-type="blocs-form" noValidate data-success-msg="Your message has been sent." data-fail-msg="Sorry it seems that our mail server is not responding, Sorry for the inconvenience!">
					<div className="form-group">
					
           
						<input id="email" name="email" onChange={handleChange} className="form-control form-style" required type="email" data-error-validation-msg="Not a valid email address" />
					</div>
					<div className="form-group">
						<input id="password" name="password" onChange={handleChange} className="form-control form-style" type="password" required placeholder="Password" />
					</div> 
					<button className="bloc-button btn btn-d btn-lg btn-style-simple float-lg-right float-sm-right float-right" type="submit">
						Login &#62;
					</button>
				</form>
			</div>
		</div>
	</div>
</div> */}
{/* <!-- bloc-5 END --> */}
</div>
{/* <!-- bloc-4 END --> */}

<section className="vh-100 gradient-custom">
  <div className="container py-5 h-100">
    <div className="row d-flex justify-content-center align-items-center h-100">
      <div className="col-12 col-md-8 col-lg-6 col-xl-5">
        <div
          className="card bg-dark text-white"
          style={{ borderRadius: "1rem" }}
        >
          <div className="card-body p-5 text-center">
            <div className="mb-md-5 mt-md-4 pb-5">
              <h2 className="fw-bold mb-2 text-uppercase">CUE ILISOUND Login</h2>
			  {error && <Alert message={error} />}
              <p className="text-white-50 mb-5">
                Please enter your login and password!
              </p>
			<form onSubmit={handleSubmit} id="form_3" data-form-type="blocs-form" noValidate data-success-msg="Your message has been sent." data-fail-msg="Sorry it seems that our mail server is not responding, Sorry for the inconvenience!">
              <div className="form-outline form-white mb-4">

                <input
                  type="email"
                  id="email"
				  name="email"
				  onChange={handleChange}
                  className="form-control form-control-lg"
                />
                <label className="form-label" htmlFor="email">
                  Email
                </label>
              </div>
              <div className="form-outline form-white mb-4">
                <input
                  type="password"
                  id="password"
				  name="password"
				  onChange={handleChange} 
                  className="form-control form-control-lg"
                />
                <label className="form-label" htmlFor="password">
                  Password
                </label>
              </div>
              <button
                className="btn btn-outline-light btn-lg px-5"
                type="submit"
              >
                Login
              </button>
			  </form>
 
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>




</div>
{/* <!-- Main container END --> */}
    



    </div>
  );
}
